import React from 'react';
import { Typography } from '../../../Typography';
import "./styles.css";
export var FileUploaderTitle = function (_a) {
    var title = _a.title, subTitle = _a.subTitle, dragOver = _a.dragOver, linkName = _a.linkName, dragOverTitle = _a.dragOverTitle;
    var localTitleVariant = dragOver ? dragOverTitle : title;
    var isTitleComponent = typeof localTitleVariant !== 'string';
    var isSubtitleComponent = typeof subTitle !== 'string';
    var localTitle = isTitleComponent ? (localTitleVariant) : (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'lk-ui_file-uploader-title_wrapper' },
            React.createElement(Typography, { variant: 'body3', className: 'lk-ui_file-uploader-title_text' }, localTitleVariant),
            ' ',
            linkName && !dragOver && (React.createElement("span", { className: 'lk-ui_file-uploader-title_link' }, linkName))),
        subTitle &&
            !dragOver &&
            (isSubtitleComponent ? (subTitle) : (React.createElement(Typography, { variant: 'body3', className: 'lk-ui_file-uploader-title_subtitle' }, subTitle)))));
    return React.createElement("div", { className: 'lk-ui_file-uploader-title' }, localTitle);
};
